import { v1BaseUrl as computedBase } from '@shared/js/apiV1.js';

// Use the Vite build-time variable when provided. Otherwise rely on the
// statically injected API_HOSTNAME from the shared helper.
export const v1BaseUrl = import.meta.env.VITE_API_V1_BASE || computedBase;
